import api from "@/api";


//列表
export const gatewayAllData = (data) => { 
    return api.axss("post", `/ocm-oil-site/gateway/all/data`,data)
}

//新增
export const gatewayInsert = (data) => { 
    return api.axss("post", `/ocm-oil-site/gateway/insert`,data)
}


//全部驱动
export const allDriver = () => { 
    return api.axss("get", `/ocm-oil-site/gateway/all/driver`)
}

//根据id查驱动
export const olistiePage = (gatewayId) => { 
    return api.axss("get", `/ocm-oil-site/gateway/all/oilsite/page?gatewayId=${gatewayId}`)
}


//修改通讯方式
export const bindDriver = (data) => { 
    // return api.axss("post", `/ocm-oil-site/gateway/bind/driver`,data)
    return api.axss("get", `/ocm-oil-site/gateway/bind/driver`, {}, data)
}


//关联润滑点
export const bindoilsite = (gatewayDriverId,gatewayId,oilSiteId) => { 

    return api.axss("get", `/ocm-oil-site/gateway/bind/oilsite?gatewayDriverId=${gatewayDriverId}&gatewayId=${gatewayId}&oilSiteId=${oilSiteId}`,)
}

//配置润滑点
export const configureParms = (data) => { 
 
    return api.axss("post", `/ocm-oil-site/gateway/configure/params`,data)
}

//解绑润滑点
export const unbindoilSite = (gatewayOilsiteId) => { 
  
    return api.axss("get", `/ocm-oil-site/gateway/unbind/oilSite?gatewayOilsiteId=${gatewayOilsiteId}`)
}


//上传产品表

export const productexcel = (data) => { 
  
    return api.axss("post", `/ocm-oil-site/gateway/product/excel`,data)
}


//上传产品表

export const getproductexcel = (id) => { 
  
    return api.axss("get", `/ocm-oil-site/gateway/device/excel?devicePointId=${id}`)
}


//网关下发

export const configThingModel = (data) => { 
  
    return api.axss("post", `/ocm-oil-site/gateway/distribution`,data)
}

//下发点表

export const distributionAdd = (data) => { 
  
    return api.axss("post", `/ocm-oil-site/gateway/distribution/add`,data,{},false)
}


//查询记录
export const gatedetalog = (gatewayId) => { 
    return api.axss("get", `/ocm-oil-site/gateway/detail/log?gatewayId=${gatewayId}`)
}



//查询记录
export const productList = (gatewayId) => { 
    
    return api.axss("get", `/ocm-oil-site/gateway/product/templete?gatewayId=${gatewayId}`)
}


//修改產品表
export const editidfe = (data) => { 
    return api.axss("post", `/ocm-oil-site/gateway/product/edit/identifer`,data)
}


//新上传产品表

export const excelup = (data) => { 
    return api.axss("post", `/ocm-oil-site/gateway/product/excel/up`,data)
}

//获取得到选择与未选择的润滑点列表
export const listoilSite = (data) => { 
    return api.axss("get", `/ocm-oil-site/gateway/list/oilSite`,data,data)
}

//关联润滑点（批量）
export const oilSitesuper = (data) => { 
    return api.axss("post", `/ocm-oil-site/gateway/bind/oilSite/super`,data)
}


//判断本次下发是否需要进行清除驱动
export const justifydriver = (data) => { 
    return api.axss("post", `/ocm-oil-site/gateway/justify/driver`,data)
}

//判断本次下发是否需要进行清除驱动
export const distributionfinish = (gatewayId) => { 
    return api.axss("get", `/ocm-oil-site/gateway/distribution/finish?gatewayId=${gatewayId}`)
}

// 下发网关
export const distributionAddAPI = (data) => api.axss('GET', `/ocm-oil-site/gateway/distribution/add`, {}, data);

// //网关下发
// export const distributionadd = (data) => { 
//     return api.axss("post", `/ocm-oil-site/gateway/distribution/add`,data)
// }

//判断本次下发是否需要进行清除驱动
export const failurenext = (gatewayId) => { 
    return api.axss("get", `/ocm-oil-site/gateway/failure/next?gatewayId=${gatewayId}`)
}



//判断本次下发是否需要进行清除驱动
export const productTemplate = (params) => { 
    return api.axss("get", `/ocm-oil-site/gateway/origin/product/template?gatewayId=${params.gatewayId}&zhuangzhiId=${params.zhuangzhiId}`)
}

